import { Injectable } from '@angular/core';
import { FMS_ATTRIBUTES_KEY } from '../app.constants';

@Injectable()
export class StorageService {
    getRawSessionStorage(key: string): string {
        return sessionStorage.getItem(key) || '';
    }

    getFromSessionStorage(key: string): string {
        return this.getRawSessionStorage(key).trim().replace(/"/g, '') || '';
    }

    getRealizeFmsAttributes(): string | null {
        return sessionStorage.getItem(FMS_ATTRIBUTES_KEY);
    }
}
